import { Box, Chip, LinearProgress, TableBody, TableCell, TableRow } from "@material-ui/core";
import React from "react";
import AppTable from "views/Admin/Component/Table/AppTable";
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import moment from "moment";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";


const headCells = [
    {
        id: "staffName",
        numeric: "left",
        disablePadding: false,
        label: "label.staffName"
    },
    {
        id: "startDate",
        numeric: "left",
        disablePadding: false,
        label: "label.startDate"
    },
    {
        id: "endDate",
        numeric: "left",
        disablePadding: false,
        label: "label.endDate"
    },
    {
        id: "status",
        numeric: "center",
        disablePadding: false,
        label: "label.status"
    }
];

const ResultPayrollTable = (props) => {
    const {
        data,
        loading,
        setShowModal
    } = props;

    const { t } = useTranslation();
    const emptyRows = data.length === 0;

    const isSuccess = (row) => {
        return row.startDate && row.endDate &&  row.payrollStatus;
    }

    return (
        <>
            <AppTable
                headCells={headCells}
            >
                <TableBody>
                    {loading && (<TableRow>
                        <TableCell colSpan={headCells.length + 1} padding="none">
                            <LinearProgress />
                        </TableCell>
                    </TableRow>)}
                    {data.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell >{ row.staffName }</TableCell>
                            <TableCell >{ row.startDate ? moment(row.startDate).format('DD/MM/yyyy') : '-' }</TableCell>
                            <TableCell >{ row.endDate ? moment(row.endDate).format('DD/MM/yyyy') : '-' }</TableCell>
                            <TableCell align="center">
                                <Chip
                                    style={{
                                        backgroundColor: isSuccess(row)
                                        ? AppColor.green
                                        : AppColor.red,
                                        color: AppColor.white,
                                    }}
                                    size="small"
                                    label={isSuccess(row) ? t("label.successful") :  t("label.failed")}
                                />
                            </TableCell>
                        </TableRow>
                    ))}

                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 }}>
                        <TableCell colSpan={headCells.length} className="text-center">
                            {t("label.no_data")}
                        </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                
            </AppTable>
            <Box mt={2} display="flex" justifyContent="flex-end">
                <AppButton
                label={t('button.close')}
                mode="outlined"
                onClick={() => setShowModal(false)}
                className="mr-2"
                />
            </Box>
        </>
    );
};

ResultPayrollTable.propTypes = {
    data: PropTypes.array,
    setShowModal: PropTypes.func,
    loading: PropTypes.bool,
}
  
export default ResultPayrollTable;
